import {dataURItoBlob} from "./common";

import {configInit, FULL_API_DOMAIN, RECOMMENDATION_METHOD,} from "../context/constants";
import {EN_STRING_MAP} from "../i18n/base";

const parseJSON = (newApi) => (response) => {
  if (
    response.status === 204 ||
    response.status === 205 ||
    response.redirected
  ) {
    return null;
  }
  return new Promise((resolve) => {
    response
      .json()
      .then((response) =>
        newApi ? resolve(response) : resolve(response.data)
      );
  });
};

const getLocation = (href) => {
  const l = document.createElement("a");
  l.href = href;
  return l;
};

const checkStatus = (response) => {
  if (response.status === undefined) {
    return response;
  }

  if (response.status >= 200 && response.status < 300 && !response.redirected) {
    return response;
  }

  if (response.redirected) {
    const url = getLocation(response.url);
    // history.push(`${url.pathname}${url.search}`);

    const error = new Error("Redirected");
    error.response = response;
    throw error;
  }

  throw response.data;

  // const error = new Error(response.data);
  // error.data = response;
  // throw error;
};

export const getRecommendProducts = (profile) => {
  const queryParams = {
    product: configInit.product.id,
    gender: profile.gender,
    height: profile.height,
    weight: profile.weight,
    age: profile.age,
    bodyType: profile.bodyType || 0,
    bustOffset: profile.bustOffset || 0,
    waistOffset: profile.waistOffset || 0,
    hipOffset: profile.hipOffset || 0,
    fitPreference: profile.fitPreference,
    band: profile.band,
    cup: profile.cup,
    neck: profile.neck,
    length: profile.length,
    rs_id: configInit.rs_id,
    body_measurement:
      Object.keys(profile.bodyMeasurement).length > 0
        ? JSON.stringify(profile.bodyMeasurement)
        : null,
  };

  const options = Object.assign(
    {},
    { product: configInit.product.id },
    queryParams
  );
  const url = new URL(`${FULL_API_DOMAIN}/api/v1/widget/recommend/products`);
  Object.keys(options).forEach((key) =>
    url.searchParams.append(key, options[key])
  );

  return fetch(url.href, {
    headers: {
      "Content-Type": "application/json",
      d: configInit.product.business.domain,
      p: configInit.product.id,
    },
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
};

export const postToApi = ({ file, ...data }) => {
  let option = {};

  const queryParams = {
    product: configInit.product.id,
    gender: data.gender,
    height: data.height,
    weight: data.weight,
    age: data.age,
    bodyType: data.bodyType || 0,
    bustOffset: data.bustOffset || 0,
    waistOffset: data.waistOffset || 0,
    hipOffset: data.hipOffset || 0,
    fitPreference: data.fitPreference,
    band: data.band,
    cup: data.cup,
    neck: data.neck,
    length: data.length,
    rs_id: configInit.rs_id,
  };

  if (data.face) {
    queryParams.face = JSON.stringify(data.face);
  }

  if (Object.keys(data.bodyMeasurement).length > 0) {
    queryParams.body_measurement = JSON.stringify(data.bodyMeasurement);
  }

  var blob = dataURItoBlob(file);
  let newfile = new File([blob], "selfie.jpg", { type: "image/jpeg" });

  let formData = new FormData();
  formData.append("image", newfile);

  if (file && configInit.product.has_virtual_model) {
    option = {
      path: `api/v1/try-on/selfie/get/`,
      method: "POST",
    };
  } else if (
    configInit.product.business.config.interview.recommendation.method !==
    RECOMMENDATION_METHOD.MEASURES
  ) {
    option = {
      path: `api/v1/widget/recommend/sizes/`,
      method: "GET",
    };
  } else {
    option = {
      path: `api/v1/widget/recommend/measures/`,
      method: "GET",
    };
  }

  const url = new URL(`${FULL_API_DOMAIN}/${option.path}`);
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, queryParams[key])
  );

  return fetch(url, {
    method: option.method,
    headers: {
      d: configInit.product.business.domain,
      p: configInit.product.id,
    },
    body: file && configInit.product.has_virtual_model ? formData : null,
  })
    .then((response) => response.json())
    .then(checkStatus)
    .then((data) => {
      if (data.data !== undefined) return data.data;
      return data;
    })
    .catch((err) => {
      throw err;
    });
};

export const quickPostToApi = ({ file, ...data }) => {
  return postToApi({ file: null, ...data });
};

export const postActivity = (action, id) => {
  const urlParams = new URLSearchParams(window.location.search);

  const queryParams = {
    product: configInit.product.id,
    rs_id: configInit.rs_id,
    _d: urlParams.get("domain"),
    _p: urlParams.get("path"),
  };
  const url = new URL(
    `${FULL_API_DOMAIN}/api/v1/widget/analytics/record/?event=${action}&business=${urlParams.get("domain")}`
  );
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.append(key, queryParams[key])
  );

  return fetch(url.href, {
    method: "POST",

    headers: {
      "Content-Type": "application/json",
      d: configInit.product.business.domain,
      p: configInit.product.id,
    },
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
};


export const getSetting = (d, p, lang) => {
  const url = new URL(`${FULL_API_DOMAIN}/api/v1/product/get/details/`);
  if (configInit.store_id) {
    url.searchParams.append("store_id", configInit.store_id);
  }
  if (lang) {
    url.searchParams.append("lang", lang);
  }

  return fetch(url, {
    headers: {
      "Content-Type": "application/json",
      d: d,
      p: p,
    },
  })
    .then(checkStatus)
    .then(parseJSON(checkStatus))
    .then((res) => {
      const newString = { ...EN_STRING_MAP };

      if (
        res.data.product.business.config?.strings === null ||
        res.data.product.business.config?.strings === undefined
      ) {
        res.data.product.business.config.strings = {};
      }

      if (Object.keys(res.data.product.business.config?.strings).length === 0) {
        res.data.product.business.config.strings = newString;
      }

      return res;
    });
};
